export const Sounds = [
  {
    id: 1,
    file: "Music1.mp3",
    preview: "/sounds/song2.mp3",
    song: "Midnight Hour",
    artist: "Raw",
    length: "3m34s",
    plays: "334.5k",
  },
  {
    id: 2,
    file: "Music2.mp3",
    preview: "/sounds/song2.mp3",
    song: "Midnight Hour",
    artist: "Raw",
    length: "2m34s",
    plays: "323.5k",
  },
  {
    id: 3,
    file: "Music3.mp3",
    preview: "/sounds/song2.mp3",
    song: "Midnight Hour",
    artist: "Raw",
    length: "1m34s",
    plays: "333.5k",
  },
];
